import { useCallback } from 'react';

import useInterval from '@swf/sports/hooks/useInterval';

import type { FetchBetsData } from './useFetchMyBets';

export type MyBetsPollingData = Pick<
  FetchBetsData,
  'bets' | 'fetchBets' | 'showLoader' | 'pollingInterval'
> & {
  isSettled: boolean;
  isLoadingMoreBets: boolean;
};

export const useMyBetsPolling = ({
  bets,
  fetchBets,
  showLoader,
  isSettled,
  pollingInterval,
  isLoadingMoreBets
}: MyBetsPollingData) => {
  const initBetsPolling = useCallback(() => {
    /**
     * Stop polling if we are loading more bets.
     * This is to prevent polling from cancelling the fetch more bets request.
     */
    if (!showLoader && !isLoadingMoreBets && bets.length && !isSettled) {
      fetchBets({ showLoader, fromRecord: 1, toRecord: bets.length });
    }
  }, [showLoader, bets, fetchBets, isSettled, isLoadingMoreBets]);

  useInterval(initBetsPolling, pollingInterval, pollingInterval);
};
